export default "__VITE_ASSET__CyON7JYR__"